

// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// import { HiOutlineMenuAlt3 } from "react-icons/hi";
// import { IoClose } from "react-icons/io5";

// import "./styles/Navbar.css";

// import logo from "../../assets/logowhite-p.png";

// const Navbar = () => {

//   const [mobileMenu, setMobileMenu] = useState(false);

//   return (
//     <>

//       <nav className="floating-navbar">

//         {/* LEFT LOGO */}

//         <div className="floating-navbar-left">

//           {/* <img
//             src={logo}
//             alt="logo"
//             className="floating-navbar-logo"
//           /> */}

//         </div>

//         {/* CENTER MENU */}

//         <div className="floating-navbar-center">

//           <Link to="/">Home</Link>

//           <Link to="/features">Features</Link>

//           <Link to="/pricing">Pricing</Link>

//           <Link to="/contact">Contact</Link>

//         </div>

//         {/* RIGHT BUTTON */}

//      {/* RIGHT SECTION */}

// <div className="floating-navbar-right">

//   <Link
//     to="/login"
//     className="floating-login-btn"
//   >
//     Login
//   </Link>


// </div>

//         {/* MOBILE ICON */}

//         <div
//           className="floating-mobile-icon"
//           onClick={() => setMobileMenu(!mobileMenu)}
//         >

//           {
//             mobileMenu
//               ? <IoClose />
//               : <HiOutlineMenuAlt3 />
//           }

//         </div>

//       </nav>

//       {/* MOBILE MENU */}

//       <div
//         className={
//           mobileMenu
//             ? "floating-mobile-menu active-floating-menu"
//             : "floating-mobile-menu"
//         }
//       >

//         <Link to="/">Home</Link>

//         <Link to="/features">Features</Link>

//         <Link to="/pricing">Pricing</Link>

//         <Link to="/contact">Contact</Link>
// <Link
//   to="/login"
//   className="mobile-login-btn"
// >
//   Login
// </Link>

// <button className="mobile-launch-btn">
//   Launch Platform
// </button>
//       </div>

//     </>
//   );
// };

// export default Navbar;




















// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// import { HiOutlineMenuAlt3 } from "react-icons/hi";
// import { IoClose } from "react-icons/io5";
// import FeaturesSection from "./sections/FeaturesSection";

// import "./styles/Navbar.css";

// const Navbar = () => {

//   const [mobileMenu, setMobileMenu] = useState(false);

//   return (
//     <>

//       {/* CENTER NAVBAR */}

//       <nav className="floating-navbar">

//         <div className="floating-navbar-center">

//           <Link to="/">Home</Link>

//           <Link to="/dashboardshowcase">Features</Link>

//           <Link to="/pricing">Pricing</Link>

//           <Link to="/contact">Contact</Link>

//         </div>

//       </nav>

//       {/* TOP RIGHT LOGIN */}

//       <div className="floating-login-wrapper">

//         <Link
//           to="/login"
//           className="floating-login-btn"
//         >
//           Login
//         </Link>

//       </div>

//       {/* MOBILE MENU ICON */}

//       <div
//         className="floating-mobile-icon"
//         onClick={() => setMobileMenu(!mobileMenu)}
//       >

//         {
//           mobileMenu
//             ? <IoClose />
//             : <HiOutlineMenuAlt3 />
//         }

//       </div>

//       {/* MOBILE MENU */}

//       <div
//         className={
//           mobileMenu
//             ? "floating-mobile-menu active-floating-menu"
//             : "floating-mobile-menu"
//         }
//       >

//         <Link to="/">Home</Link>

//         <Link to="/features">Features</Link>

//         <Link to="/pricing">Pricing</Link>

//        <a href="#contact">Contact</a>

//         <Link
//           to="/login"
//           className="mobile-login-btn"
//         >
//           Login
//         </Link>

//       </div>

//     </>
//   );
// };

// export default Navbar;












import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import {
  Users,
  UserPlus,
  Handshake,
  Wallet,
  Package,
  ShoppingCart,
  Boxes,
  ChevronDown
} from "lucide-react";
import logo from "../../assets/logo-white-r.png";

import "./styles/Navbar.css";

const productsList = [
  {
    name: "GTELINQ HRMS",
    description: "Complete Human Resource Management System",
    path: "/products/gtelinq",
    icon: <Users size={20} />
  },
  {
    name: "Hiring Hub",
    description: "Smart Recruitment & Applicant Tracking",
    path: "/products/hiring-hub",
    icon: <UserPlus size={20} />
  },
  {
    name: "CRM",
    description: "Customer Relationship Management Platform",
    path: "/products/crm",
    icon: <Handshake size={20} />
  },
  {
    name: "Payroll",
    description: "Automated Payroll & Salary Processing",
    path: "/products/payroll",
    icon: <Wallet size={20} />
  },
  {
    name: "Inventory Management",
    description: "Real-time stock tracking & low stock alerts",
    path: "/products/inventory",
    icon: <Package size={20} />
  },
  {
    name: "Purchase & Procurement",
    description: "Centralized RFQs, vendor directories, & PO audits",
    path: "/products/procurement",
    icon: <ShoppingCart size={20} />
  },
  {
    name: "Warehouse Management",
    description: "Map bin locations & suggest storage placements",
    path: "/products/warehouse",
    icon: <Boxes size={20} />
  }
];

const Navbar = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const location = useLocation();

  const isMobile = screenWidth < 900;

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isCRMPage = location.pathname.toLowerCase().replace(/\/$/, "") === "/products/crm";
  const isHiringHubPage = location.pathname.toLowerCase().replace(/\/$/, "") === "/products/hiring-hub";

  return (
    <>
      {/* TOP LEFT FIXED LOGO */}
      <div style={{
        position: "fixed",
        top: isMobile ? "20px" : "36px",
        left: isMobile ? "20px" : "40px",
        zIndex: 10000,
        pointerEvents: "auto"
      }}>
        <Link to="/">
          <img 
            src={logo} 
            alt="GTELINQ" 
            style={{ 
              height: isMobile ? "26px" : "38px", 
              width: "auto", 
              display: "block",
              imageRendering: "-webkit-optimize-contrast" 
            }} 
          />
        </Link>
      </div>

      {/* CENTER NAVBAR */}
      <nav className="floating-navbar">
        <div className="floating-navbar-center">
          <Link to="/">Home</Link>

          <div className="products-dropdown">
            <span className="products-trigger">
              Products <ChevronDown size={14} className="chevron-icon" />
            </span>
            <div className="products-menu-mega">
              {productsList.map((prod, idx) => (
                <Link key={idx} to={prod.path} className="mega-menu-item">
                  <div className="mega-menu-icon">{prod.icon}</div>
                  <div className="mega-menu-text">
                    <span className="mega-menu-title">{prod.name}</span>
                    <span className="mega-menu-desc">{prod.description}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* <Link to="/pricing">Pricing</Link> */}
          <Link to="/contact">Contact</Link>
        </div>
      </nav>

      {/* TOP RIGHT FIXED LOGIN BUTTON */}
      {!isMobile && (
        <div className="floating-login-wrapper">
          {isCRMPage ? (
            <a href="https://crm.gtelinq.com/login" className="floating-login-btn">
              Login
            </a>
          ) : isHiringHubPage ? (
            <a href="https://hiring.gtelinq.com/" className="floating-login-btn">
              Login
            </a>
          ) : (
            <Link to="/login" className="floating-login-btn">
              Login
            </Link>
          )}
        </div>
      )}

      {/* MOBILE MENU ICON */}
      <div
        className="floating-mobile-icon"
        onClick={() => setMobileMenu(!mobileMenu)}
      >
        {mobileMenu ? <IoClose /> : <HiOutlineMenuAlt3 />}
      </div>

      {/* MOBILE MENU */}
      <div
        className={
          mobileMenu
            ? "floating-mobile-menu active-floating-menu"
            : "floating-mobile-menu"
        }
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px", borderBottom: "1px solid rgba(255, 255, 255, 0.05)", paddingBottom: "15px" }}>
          <img 
            src={logo} 
            alt="GTELINQ" 
            style={{ 
              height: "36px", 
              width: "auto", 
              imageRendering: "-webkit-optimize-contrast" 
            }} 
          />
        </div>

        <Link to="/" onClick={() => setMobileMenu(false)}>
          Home
        </Link>

        <div className="mobile-products-collapsible">
          <div
            className="mobile-products-title"
            onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
            style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}
          >
            Products <ChevronDown size={16} style={{ transform: mobileProductsOpen ? "rotate(180deg)" : "none", transition: "0.2s" }} />
          </div>
          {mobileProductsOpen && (
            <div className="mobile-products-list">
              {productsList.map((prod, idx) => (
                <Link
                  key={idx}
                  to={prod.path}
                  onClick={() => {
                    setMobileMenu(false);
                    setMobileProductsOpen(false);
                  }}
                  style={{ paddingLeft: "15px", fontSize: "18px", color: "#aaa" }}
                >
                  • {prod.name}
                </Link>
              ))}
            </div>
          )}
        </div>

        {/* <Link to="/pricing" onClick={() => setMobileMenu(false)}>
          Pricing
        </Link> */}

        <Link to="/contact" onClick={() => setMobileMenu(false)}>
          Contact
        </Link>

        {isCRMPage ? (
          <a 
            href="https://crm.gtelinq.com/login" 
            className="mobile-login-btn" 
            onClick={() => setMobileMenu(false)}
          >
            Login
          </a>
        ) : isHiringHubPage ? (
          <a 
            href="https://hiring.gtelinq.com/" 
            className="mobile-login-btn" 
            onClick={() => setMobileMenu(false)}
          >
            Login
          </a>
        ) : (
          <Link to="/login" className="mobile-login-btn" onClick={() => setMobileMenu(false)}>
            Login
          </Link>
        )}
      </div>
    </>
  );
};

export default Navbar;






